module KendoWidgets
{
	export class TabStripOptions implements kendo.ui.TabStripOptions
	{
		name?: string;
		width?: string | number;
		height?: string | number;
		selectedIndex?: number;
		animation?: any;
		dataSource?: any | any | kendo.data.DataSource;
		dataTextField?: string;
		dataUrlField?: string;
		value?: string;

		label?: string;
		addButton?: boolean;
		items?: TabStripItem[];
		buttons?: TabStripItemButton[];
		draggable?: boolean;
		scrollable?: boolean;

		contentLoad?(e: kendo.ui.TabStripContentLoadEvent): void;
		select?(e: kendo.ui.TabStripSelectEvent): void;
		show?(e: kendo.ui.TabStripShowEvent): void;
		addButtonClick?(e: TabStripAddButtonClickEvent): void;
	}

	export class TabStrip extends kendo.ui.TabStrip implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.TabStrip; }

		constructor(element: Element, options?: KendoWidgets.TabStripOptions)
		{
			if (options == null)
				options = new KendoWidgets.TabStripOptions();

			if (options.addButton == null) options.addButton = false;
			if (options.items == null) options.items = [];
			if (options.draggable == null) options.draggable = false;

			(options as any).dataTextField = "text";
			(options as any).dataSpriteCssClass = "icon";

			//#region Width
			if (options.width != null)
				$(element).css("width", options.width);

			if (options.height != null)
				$(element).css("height", options.height);
			//#endregion			

			super(element, options);

			this.setItems(options.items);

			//#region Selected index
			if (options.selectedIndex != null)
			{
				this.select(options.selectedIndex);
				let tab = this.getTabByIndex(options.selectedIndex);
				tab!.element.click();
			}
			//#endregion

			//#region Label
			if (options.label != null)
			{
				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						height: 21,
						fontSize: 14,
						width: "auto"
					});

				$(label).addClass("k-label-top");
				element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column; width: 100%;";
				element.parentElement!.insertBefore(label, element.parentElement!.firstChild);

				(element as HTMLElement).style.cssText += "width: 100%";
			}
			//#endregion
		}

		//#region Tab management
		getTabByIndex(index: number): KendoWidgets.Tab | null
		{
			let tabElement: HTMLSpanElement | null = null;
			let tabStripItems = this.element.find(".k-tabstrip-items")[0] as HTMLUListElement;
			if (tabStripItems != null)
			{
				let childrenLi = tabStripItems.children[index] as HTMLLIElement;
				if (childrenLi != null)
					tabElement = $(childrenLi).find(".k-link")[0] as HTMLSpanElement;
			}

			if (tabElement != null)
			{
				let tab = new Tab();
				tab.element = tabElement;
				tab.index = index;
				return tab;
			}
			else
				return null;
		}

		getTabByName(name: string): KendoWidgets.Tab | null
		{
			let tabElement: HTMLSpanElement | null = null;
			let tabStripItems = this.element.find(".k-tabstrip-items")[0] as HTMLUListElement;
			let i = 0;
			if (tabStripItems != null)
			{
				for (let childrenLi of Array.from(tabStripItems.children))
				{
					let spanElement = $(childrenLi).find(".k-link")[0] as HTMLSpanElement;
					if ($(childrenLi).attr("name") === name)
					{
						tabElement = spanElement;
						break;
					}
					i++;
				}
			}

			if (tabElement != null)
			{
				let tab = new Tab();
				tab.element = tabElement;
				tab.index = i;
				return tab;
			}
			else
				return null;
		}

		enableTab(index: number)
		{
			let tab = this.getTabByIndex(index);
			if (tab != null)
				$(tab.element.parentElement!).removeClass("k-tabstrip-disabled");
		}

		disableTab(index: number)
		{
			let tab = this.getTabByIndex(index);
			if (tab != null)
				$(tab.element.parentElement!).addClass("k-tabstrip-disabled");
		}

		showTab(index: number)
		{
			let tab = this.getTabByIndex(index);
			if (tab != null)
				$(tab.element.parentElement!).show();
		}

		hideTab(index: number)
		{
			let tab = this.getTabByIndex(index);
			if (tab != null)
				$(tab.element.parentElement!).hide();
		}

		selectTabByIndex(index: number, triggerChange = true)
		{
			let tab = this.getTabByIndex(index);
			if (tab != null)
			{
				this.select(tab.element.parentElement!);
				if (triggerChange)
					$(tab.element).click();
			}
		}
		//#endregion

		//#region Items
		getItems(): TabStripItem[]
		{
			let items: TabStripItem[] = [];
			let dataSourceItems = this.dataSource.options.data;
			for (let dataSourceItem of dataSourceItems)
			{
				let item = new TabStripItem();
				item.text = dataSourceItem.text;
				item.icon = dataSourceItem.icon;
				item.imageUrl = dataSourceItem.imageUrl;
				item.value = dataSourceItem.value;
				item.container = dataSourceItem.container;
				item.click = dataSourceItem.click;
				items.push(item);
			}
			return items;
		}

		setItems(items: TabStripItem[])
		{
			let options = this.getOptions();

			//#region AddButton
			if (options.addButton)
			{
				let addDefaultButton = items.filter(k => k != null && k.value == "addDefaultButton")[0];
				if (addDefaultButton != null && addDefaultButton.value != null)
				{
					items.deleteItem(addDefaultButton, "value");
					items.push(addDefaultButton);
				}
				else
				{
					let that = this;
					let addButtonItem = new TabStripItem();
					addButtonItem.icon = "add";
					addButtonItem.value = "addDefaultButton";
					addButtonItem.click = () =>
					{
						kendo.prompt("Inserisci un nome per la scheda:", "nuovaScheda").then(function (value)
						{
							let newItem = new TabStripItem();
							newItem.text = value;
							that.addItem(newItem);

							if (options!.addButtonClick != null)
							{
								let addButtonClickEvent = new TabStripAddButtonClickEvent();
								addButtonClickEvent.newTabItem = newItem;
								options!.addButtonClick(addButtonClickEvent);
							}
						});
					};
					items.push(addButtonItem);
				}
			}
			//#endregion

			let itemContainerList: (string | JQuery | Element)[] = [];
			let dataSourceItems: any[] = [];
			for (let i = 0; i < items.length; i++)
			{
				let item = items[i];
				if (item == null)
					continue;

				item.value = (item.value != null) ? item.value : item.text;

				let dataSourceItem: any = {};
				dataSourceItem.text = (item.text != null) ? item.text : "";
				dataSourceItem.value = (item.value != null) ? item.value : "";
				dataSourceItem.click = item.click;

				if (item.container != null)
					dataSourceItem.container = item.container;

				if (item.icon != null)
					dataSourceItem.icon = "k-icon k-i-" + item.icon;
				else if (item.imageUrl != null)
					dataSourceItem.icon = "imageUrl";

				dataSourceItems.push(dataSourceItem);

				if (item.container != null)
					itemContainerList.push(item.container);
			}

			let dataSource = (kendo.data.DataSource as any).create(dataSourceItems);
			this.setDataSource(dataSource);

			//#region Events
			for (let i = 0; i < items.length; i++)
			{
				let item = items[i];
				if (item == null)
					continue;

				let tab = this.getTabByIndex(i);
				if (tab != null)
				{
					//#region Buttons
					if (options.buttons != null && item.value !== "addDefaultButton")
					{
						for (let button of options.buttons)
						{
							let icon = button.icon;
							let confirmationMessage = (button.confirmationMessage == null) ? "" : button.confirmationMessage;
							switch (button.type)
							{
								case TabStripItemButtonType.Delete:
									{
										if (button.icon == null)
											icon = IconClass.Delete;

										if (button.confirmationMessage == null)
											confirmationMessage = "Confermi di voler eliminare la scheda?";
									}
									break;
								case TabStripItemButtonType.Edit:
									{
										if (button.icon == null)
											icon = IconClass.Edit
									}
									break;
								default:
							}

							let buttonElement = $("<button></button>").appendTo(tab.element.parentElement!)[0];
							$(buttonElement).kendoButton(
								{
									icon: icon,
									css: "background: none; border: none;" + button.css,
									confirmationMessage: confirmationMessage,
									click: (e) =>
									{
										if (button.type == TabStripItemButtonType.Delete)
											this.deleteItem(item.text);
										else if (button.type == TabStripItemButtonType.Edit)
										{
											let that = this
											kendo.prompt("Modifica nome scheda", item.text).then(function (value)
											{
												that.labelItem(item.text, value);
												if (button.click != null)
												{
													let clickEvent = new TabStripItemButtonClickEvent();
													clickEvent.tabName = value;
													button.click(clickEvent);
												}
											});
											return;
										}

										if (button.click != null)
										{
											let clickEvent = new TabStripItemButtonClickEvent();
											clickEvent.tabName = item.text;
											button.click(clickEvent);
										}
									}
								});
							//$(tab.element).css("padding-left", "0px");
						}
					}
					//#endregion

					//#region Icon/Image
					if (item.icon != null)
						$(tab.element).children(".k-icon").removeClass("k-sprite");
					else if (item.imageUrl != null)
					{
						let span = Array.from($(tab.element).children(".imageUrl"))[0];
						$(span).append("<img src='" + item.imageUrl + "' />");
					}
					//#endregion

					//#region Click
					$(tab.element).click(() =>
					{
						//#region Show/Hide container
						if (item.container != null)
						{
							for (let container of itemContainerList)
							{
								let containerObject = this.getElementByObject(container);
								$(containerObject).hide();
							}

							let itemContainer = this.getElementByObject(item.container);
							$(itemContainer).show();
						}
						//#endregion

						if (item.click != null)
						{
							let tablClickEvent = new TabStripClickEvent();
							tablClickEvent.text = item.text;
							item.click!(tablClickEvent);
						}
					});
					//#endregion

					$(tab.element).parent().attr("value", item.value!);
					$(tab.element).parent().attr("name", item.text!);

					//#region Drag
					if (options.draggable)
					{
						$(tab.element).parent().mousedown((emd: JQueryMouseEventObject) =>
						{
							let startingXPosition = emd.clientX;
							let startingYPosition = emd.clientY;
							let tabTarget = $(emd.currentTarget);
							let isMoved = false;
							let width = tabTarget.width();

							// Moving
							$(document).mousemove((emm: JQueryMouseEventObject) => 
							{
								let actualXPosition = emm.clientX;
								let actualYPosition = emm.clientY;
								let xDiff = startingXPosition - actualXPosition;
								let yDiff = startingYPosition - actualYPosition;

								if (!(emm.clientX == startingXPosition && emm.clientY == startingYPosition))
								{
									let elementToDrag: JQuery = tabTarget;
									elementToDrag.offset({ top: tabTarget.offset().top, left: (emm.clientX - ($(tabTarget[0]).width() / 2)) });
								}

								if (Math.abs(xDiff) > Math.abs(yDiff))
								{
									let value = tabTarget.attr("value");
									let itemTarget = items.filter(k => k != null && k.value == value)[0];
									let itemTargetIndex = items.findIndex(k => k != null && k.value == value);
									let itemTargetTemp = jQuery.extend(true, {}, itemTarget);
									isMoved = true;

									if (xDiff > 50) // Left
									{
										if (items[itemTargetIndex - 1] != null)
										{
											items[itemTargetIndex] = items[itemTargetIndex - 1];
											items[itemTargetIndex - 1] = itemTargetTemp;
											startingXPosition -= 50;
										}
									}
									else if (xDiff < -50) // Right
									{
										if (items[itemTargetIndex + 1] != null)
										{
											items[itemTargetIndex] = items[itemTargetIndex + 1];
											items[itemTargetIndex + 1] = itemTargetTemp;
											startingXPosition += 50;
										}
									}
								}
							});

							// Stop moving
							$(document).mouseup((e) =>
							{
								$(document).unbind("mousedown");
								$(document).unbind("mouseup");
								$(document).unbind("mousemove");

								if (isMoved)
								{
									this.setItems(items);

									let value = tabTarget.attr("value");
									let itemTargetIndex = items.findIndex(k => k != null && k.value == value);
									this.selectTabByIndex(itemTargetIndex);
								}
							});
						});
					}
					//#endregion
				}
			}
			//#endregion

			this.element.children(".k-tabstrip-items").prependTo(this.element);
		}

		labelItem(name: string, newName: string)
		{
			let newTab = this.getTabByName(newName);
			if (newTab == null)
			{
				let tab = this.getTabByName(name);
				if (tab != null)
					tab.setLabelText(newName);

				return true;
			}
			else
			{
				this.showNotification("Non possono esistere due schede con lo stesso nome");
				return false;
			}
		}

		addItem(item: TabStripItem)
		{
			if (!this.isDuplicate(item))
			{
				let actualItems = this.getItems();
				actualItems.push(item);
				this.setItems(actualItems);

				this.selectTabByIndex(actualItems.length - 2);
			}
			else
				this.showNotification("Non possono esistere due schede con lo stesso nome");
		}

		deleteItem(name: string, removeFromDataSource = true)
		{
			let itemToDelete = (this.dataSource.options.data as any[]).filter(k => k.text === name)[0];
			if (removeFromDataSource)
				(this.dataSource.options.data as any[]).deleteBy(k => k.text === name);
			let tab = this.getTabByName(name);
			if (tab != null)
			{
				$(tab.element).parent().remove();
				if (itemToDelete != null && itemToDelete.container != null)
					$(itemToDelete.container).empty();

				if (this.getItems().length > 1)
					this.selectTabByIndex(0);
			}
		}

		clearItems()
		{
			let itemstoDelete = this.dataSource.options.data
			let index = 0;
			for (let item of itemstoDelete)
			{
				//this.deleteItem(item.text, false);
				let tab = this.getTabByIndex(index);
				if (tab != null)
				{
					$(tab.element).parent().remove();
					if (item != null && item.container != null)
					{
						if (!item.container.startsWith("#"))
							item.container = "#" + item.container;

						$(item.container).remove();
					}
				}
				index++;
			}
			this.dataSource.options.data = [];
		}
		//#endregion

		//#region Utility
		private getElementByObject(object: string | Element | JQuery): Element
		{
			let element = object as Element;
			if (typeof (object) === "string")
			{
				if (!object.startsWith("#"))
					object = "#" + object;

				element = $(object)[0];
			}
			else if (object instanceof jQuery)
				element = $(object)[0];

			return element;
		}

		isDuplicate(item: TabStripItem)
		{
			return this.getTabByName(item.text) != null;
		}

		enableAll(value?: boolean)
		{
			let items = this.getItems();
			if (value != null)
			{
				for (let i = 0; i < items.length; i++)
				{
					if (value == true)
						this.enableTab(i);
					else
						this.disableTab(i);
				}
			}

			let allEnabled = true;
			for (let i = 0; i < items.length; i++)
			{
				let tab = this.getTabByIndex(i);
				if (tab != null && $(tab.element.parentElement!).hasClass("k-tabstrip-disabled"))
				{
					allEnabled = false;
					break;
				}
			}
			return allEnabled;
		}

		clear()
		{
			this.select(0);
		}

		selectedIndex(e?: kendo.ui.TabStripSelectEvent)
		{
			if (e != null)
			{
				let index = $(e.item!).index();
				if (index >= 0)
					return $(e.item!).index();
			}
			return this.element.find(".k-state-active").index();
		}

		getOptions()
		{
			return (this.options as KendoWidgets.TabStripOptions);
		}
		//#endregion

		//#region Notification
		private showNotification(message: string)
		{
			let that = this;
			let divNotificationFragment = document.createDocumentFragment();

			$("#notificationManagerDivNotification").remove();
			let divNotification = document.createElement("div");
			divNotification.id = "notificationManagerDivNotification"
			divNotification.classList.add("cssNotificationManagerDivNotification");
			divNotification.style.cssText += "background-color: #E3F1FA; border: solid 2px #51B3E1;";
			divNotificationFragment.appendChild(divNotification);
			document.getElementsByTagName("body")![0].appendChild(divNotificationFragment);

			divNotification.style.cssText += "display: flex; flex-direction: column; justify-content: center;";
			divNotification.innerHTML = DOMPurify.sanitize("<div style='max-width: 500px;'>" + message + "</div>");

			let elementHeight = divNotification.clientHeight;

			//#region Slide down from top
			let toPosition = 0;
			let fromPosition = elementHeight - (2 * elementHeight);
			let speedInMilliseconds = 5;

			let id = setInterval(SlideDownFromTop, speedInMilliseconds);

			function SlideDownFromTop()
			{
				if (fromPosition == toPosition)
					clearInterval(id);
				else
				{
					fromPosition++;
					divNotification.style.top = fromPosition + "px";
				}
			}
			//#endregion

			setTimeout(function ()
			{
				that.hideNotification();
			}, 5000);
		}

		private hideNotification()
		{
			let divNotification = document.getElementById("notificationManagerDivNotification");
			if (divNotification != null)
			{
				let elementHeight = divNotification.clientHeight;

				//#region Slide up to top
				let toPosition = elementHeight - (2 * elementHeight);
				let fromPosition = 0;
				let speedInMilliseconds = 5;

				let id = setInterval(SlideUpToTop, speedInMilliseconds);

				function SlideUpToTop()
				{
					if (fromPosition == toPosition)
					{
						clearInterval(id);
						divNotification!.style.display = "none";
					}
					else
					{
						fromPosition--;
						divNotification!.style.top = fromPosition + "px";
					}
				}
				//#endregion
			}
		}
		//#endregion

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
		//#endregion
	}

	//#region Classes
	export class Tab
	{
		public element: HTMLSpanElement;
		public index: number;

		setLabelText(text: string)
		{
			this.element.textContent = text;
		}

		getLabelText()
		{
			return this.element.innerHTML;
		}
	}

	class TabStripClickEvent
	{
		text: string;
	}

	class TabStripAddButtonClickEvent
	{
		newTabItem: TabStripItem;
	}

	class TabStripItem
	{
		text: string;
		value?: string;
		icon?: string;
		imageUrl?: string;
		container?: HTMLElement | JQuery | string;

		click?(e: TabStripClickEvent): void;
	}

	class TabStripItemButton
	{
		type: TabStripItemButtonType;
		icon?: string;
		css?: string;
		confirmationMessage?: string;
		click?: (e: TabStripItemButtonClickEvent) => void;
	}

	class TabStripItemButtonClickEvent
	{
		tabName: string;
	}

	export enum TabStripItemButtonType
	{
		Delete,
		Edit,
		Custom
	}
	//#endregion

	TabStrip.fn = TabStrip.prototype;
	TabStrip.fn.options = $.extend(true, {}, kendo.ui.TabStrip.fn.options);
	TabStrip.fn.options.name = "TabStrip";
	kendo.ui.plugin(TabStrip);
}

interface JQuery
{
	kendoTabStrip(options?: KendoWidgets.TabStripOptions): JQuery;
}